<template>
  <section ref="scrollContainerRef" class="history-scroll">
    <WorkspaceChatTicket
      :item="history"
      :readonly="true"
      :disabled="disabled"
      @scroll-to-message="handleScrollToMessage"
    />
    <NewMessagesAlert
      :count="newMessages"
      @click="scrollToBottom"
    />
  </section>
</template>

<script>
import { inject, ref, onUpdated, onMounted, nextTick } from "vue";

import WorkspaceChatTicket from "@/app/workspace/components/chat/WorkspaceChatTicket.vue";
import NewMessagesAlert from "@/app/workspace/components/chat/messages/NewMessagesAlert.vue";
import { ChannelType } from "@/app/shared/utils/enums";

export default {
  components: {
    // CustomScrollbar,
    WorkspaceChatTicket,
    NewMessagesAlert,
  },
  props: {
    history: { required: true, type: Array },
    expanded: { type: Boolean, default: false },
    channelId: { type: Number },
    disabled: { required: false, type: Boolean, default: false },
  },
  setup(_, { expose }) {
    const ticket = inject("selectedTicket");
    const showBanner = inject("showBanner");
    const scrollContainerRef = ref(null);
    const count = ref(0);
    const newMessages = ref(0);
    const scrollToBottom = () => {
      scrollContainerRef.value.scroll({
        top: scrollContainerRef.value.scrollHeight,
        behavior: "smooth",
      });
      newMessages.value = 0;
    };

    const firstCharge = ref(true);

    onUpdated(() => {
      if (firstCharge.value) {
        firstCharge.value = false;
        scrollToBottom();
        return;
      }
    });

    onMounted(() => {
      scrollToBottom();

      // limpiar nuevos mensajes si el scroll llega abajo
      const el = scrollContainerRef.value;
      if (!el) return;

      el.addEventListener("scroll", () => {
        if (isAtBottom()) {
          newMessages.value = 0;
        }
      });
    });

    const isAtBottom = () => {
      const el = scrollContainerRef.value;
      if (!el) return false;

      const threshold = 30; // margen para considerar "abajo"
      return el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
    };

    const handleScrollToMessage = async (messageId) => {
      await nextTick()

      const container = scrollContainerRef.value
      if (!container) return

      const target = container.querySelector(`[data-message-id="${messageId}"]`)
      if (!target) return

      // calculo de posición relativa usando offsetTop acumulado
      let offsetTop = target.offsetTop
      let parent = target.offsetParent
      while (parent && parent !== container) {
        offsetTop += parent.offsetTop
        parent = parent.offsetParent
      }

      const extraMargin = 15

      offsetTop = Math.max(offsetTop - extraMargin, 0)

      container.scrollTo({
        top: offsetTop - container.clientHeight / 2, // centrado aproximado
        behavior: 'smooth'
      })

      target.classList.add('highlight')
      setTimeout(() => target.classList.remove('highlight'), 1500)
    }

    expose({
      scrollToBottom,
      isAtBottom,
    });

    return { showBanner, scrollContainerRef, handleScrollToMessage, count, ticket, newMessages, scrollToBottom, isAtBottom };
  },
  computed: {
    heightStyle() {
      const size = this.expanded ? 255 : 180;
      return this.showBanner ? `calc(100vh - ${size}px - 35px` : `calc(100vh - ${size}px`;
    },
  },
  methods: {
    isLast(index) {
      return index === this.history.length - 1;
    },
  },
  sockets: {
    async refreshTickets(data) {
      const ticketMessageAssigned = data?.ticket_message_assigned || false;
     
      const isChat = ![ChannelType.VoiceInbound, ChannelType.Voice, null].includes(data.channel_id);

      if (data.ticketid === this.ticket.id && isChat && !ticketMessageAssigned) {
        if (!this.isAtBottom()) {
          this.newMessages ++;
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.history-scroll
  // height: calc(100% - 96px)
  overflow-y: auto
  scrollbar-width: thin
  scrollbar-color: #c1c1c1 transparent
  margin-right: 4px
  flex: 1 1 auto

  &::-webkit-scrollbar
    position: absolute
    width: 4px

  &::-webkit-scrollbar-track
    background: transparent

  &::-webkit-scrollbar-thumb
    background-color: #c1c1c1
    border-radius: 2px
</style>
